<div class="manager-loader-wrapper-page" [ngClass]="appS.navigationS.navigations[this.type + '.' + this.wrapper]?.step">
  <div class="spinner-border w-55px h-55px"></div>
</div>
